var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZero = function SvgZero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.842 12.799h12.553L13.393.805.842 12.8Zm36.373 5.199c-3.223-3.535-8.753-3.811-12.315-.604-3.559 3.207-3.832 8.7-.607 12.239 3.001 3.293 8.006 3.755 11.555 1.211l2.076 2.07-.65.647 7.448 7.419L48 37.718l-7.45-7.416-.648.645-2.074-2.069c2.347-3.24 2.192-7.802-.613-10.88Zm-10.436 1.459c2.419-2.177 6.172-1.992 8.36.41a5.866 5.866 0 0 1-.412 8.307c-2.417 2.176-6.172 1.99-8.359-.41a5.866 5.866 0 0 1 .41-8.307ZM0 15.58V44h33.838V33.278c-3.656 1.17-7.811.177-10.508-2.783-3.699-4.058-3.386-10.38.698-14.056 2.741-2.469 6.51-3.14 9.81-2.087V0H16.192v15.578L0 15.581Z",
    fill: "#CCC"
  })));
};
export default SvgZero;